import WelcomeAlert from './WelcomeAlert';

const HomePage = () => <WelcomeAlert />;

export default HomePage;
